import i18n from "@i18n/i18n";
import { Container, Grid, Typography } from "@mui/material";
import { observer } from "mobx-react";
import Co2MaterialTypeByCategoryGrid from "./Co2MaterialTypeByCategoryGrid";

const Co2MaterialTypeByCategoryPage = observer(() => {
  return (
    <Container maxWidth={false} sx={{ height: "100%" }}>
      <Grid mt={2} container spacing={2} sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Grid size={12} sx={{ display: "flex", flexGrow: 0 }}>
          <Typography variant="h6" fontWeight="bold">
            {i18n.t("aggregated-data-tab.title")}
          </Typography>
        </Grid>
        <Grid size={12} sx={{ display: "flex", flexGrow: 1, width: "100%", position: "relative" }}>
          <Co2MaterialTypeByCategoryGrid />
        </Grid>
      </Grid>
    </Container>
  );
});

export default Co2MaterialTypeByCategoryPage;
